import axios from 'axios';
import React,{useState, useEffect,} from 'react'
import {CopyToClipboard} from 'react-copy-to-clipboard';



function Linkresult({inputValue}) {
    const [shortenLink, setShortenLink] = useState("")
    const [error, setError] = useState(false)

    const[copied, setCopied] = useState(false)

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const timer = setTimeout(() => {
            setCopied(false)
        }, 1000);

        return () => clearTimeout(timer);
    }, [copied]);

  

    const fetchData = async () => {
        try {
            const res = await axios(`https://api.shrtco.de/v2/shorten?url=${inputValue}`);
            setShortenLink(res.data.result.full_short_link);
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if(inputValue.length){
            fetchData();
        }
    });

    if(loading){
        return <p className='noData'>Loading....</p>
    }

    if(error){
        return <p className='noData'>Something Went wrong : {error}</p>
    }

  return (
      <>
      {
          shortenLink && (
            <div className='result flex-col sm:flex-row flex items-center justify-center p-2 px-4 sm:px-24 text-center sm:text-justify'>
            <p className='border border-slate-400 p-2 mr-4 w-full my-4'>{inputValue} <span className='float-right text-c'>{shortenLink}</span></p>
    <CopyToClipboard text={shortenLink} onCopy={() => setCopied(true)}>
    <button className={copied ? "copied" : ""}>{copied ? 'copied' : 'copy'}</button>    
    </CopyToClipboard>   
        </div>
          )
      }
      
      </>

  )
}

export default Linkresult